export const QueryKeyEnum = {
  ADMINISTRATION: {
    CREATE_MAINTENANCE_WINDOW: 'ADMINISTRATION_CREATE_MAINTENANCE_WINDOW',
    FINISH_MAINTENANCE_WINDOW: 'ADMINISTRATION_FINISH_MAINTENANCE_WINDOW',
    MAINTENANCE_WINDOWS: 'ADMINISTRATION_MAINTENANCE_WINDOWS',
    PERMISSIONS: 'ADMINISTRATION_PERMISSIONS',
    ROLES: 'ADMINISTRATION_ROLES',
    UPDATE_ROLE_PERMISSIONS: 'ADMINISTRATION_UPDATE_ROLE_PERMISSIONS',
    UPDATE_USER_ACCESS: 'ADMINISTRATION_UPDATE_USER_ACCESS',
    USERS: 'ADMINISTRATION_USERS',
  },
  ANNOUNCEMENTS: {
    MARK_SEEN: 'ANNOUNCEMENTS_MARK_SEEN',
    SEEN: 'ANNOUNCEMENTS_SEEN',
  },
  CALENDARS: {
    ALL: 'CALENDARS_ALL',
    EVENTS: 'CALENDARS_EVENTS',
  },
  CARS: {
    ALL: 'CARS_ALL',
    ATTENTION: 'CARS_ATTENTION',
    CANCEL_DEADLINE_PLAN: 'CARS_CANCEL_DEADLINE_PLAN',
    DEADLINES: 'CAR_DEADLINES',
    DELETE_ISSUE: 'CARS_DELETE_ISSUE',
    DELETE_LOG_ENTRY: 'CARS_DELETE_LOG_ENTRY',
    DETAILS: 'CAR_DETAILS',
    ISSUES: 'CAR_ISSUES',
    LOG_ENTRIES: 'CAR_LOG_ENTRIES',
    PLAN_DEADLINE: 'CARS_PLAN_DEADLINE',
    SAVE_ISSUE: 'CARS_SAVE_ISSUE',
    SAVE_LOG_ENTRY: 'CARS_SAVE_LOG_ENTRY',
    UPDATE_DEADLINE: 'CARS_UPDATE_DEADLINE',
  },
  CATALOG: {
    DISHES: 'CATALOG_DISHES',
    IMPORTS: 'CATALOG_IMPORTS',
    OFFER_ELEMENTS: 'CATALOG_OFFER_ELEMENTS',
    SEARCH: 'CATALOG_SEARCH',
    SETS: 'CATALOG_SETS',
  },
  CATALOG_RESET: {
    RESET: 'CATALOG_RESET_RESET',
    SUMMARY: 'CATALOG_RESET_SUMMARY',
  },
  CHATS: {
    ALL: 'ALL_CHATS',
    ALL_STATUS: 'ALL_STATUS',
    ID: 'CHATS_ID',
    READ_STATUSES: 'CHATS_READ_STATUSES',
    SEND: 'CHATS_SEND',
    SET_READ: 'SET_READ',
  },
  CONTACTS: {
    ALL: 'CONTACTS_ALL',
    CREATE: 'CONTACTS_CREATE',
    DETAILS: 'CONTACT_DETAILS',
    SHORT: 'CONTACTS_SHORT',
    UPDATE: 'CONTACTS_UPDATE',
  },
  CUSTOMERS: {
    ALL: 'CUSTOMERS_ALL',
    CONTACTS: 'CUSTOMERS_CONTACTS',
    DETAILS: 'CUSTOMER_DETAILS',
    DUPLICATE: 'CUSTOMER_DUPLICATE',
    TYPE: 'CUSTOMER_TYPE',
  },
  DASHBOARD: {
    EMAILS: 'DASHBOARD_EMAILS',
    EXPIRY: 'DASHBOARD_EXPIRY',
    TASKS: 'DASHBOARD_TASKS',
  },
  DICTIONARIES: {
    ALL: 'DICTIONARIES_ALL',
    DETAILS: 'DICTIONARY_DETAILS',
    SEARCH: 'DICTIONARIES_SEARCH',
  },
  DISH_DETAILS: 'DISH_DETAILS',
  DISH_EDITOR: {
    ADD_PORTION: 'DISH_EDITOR_ADD_PORTION',
    BROWSE_PAGE: 'DISH_EDITOR_BROWSE_PAGE',
    CREATE: 'DISH_EDITOR_CREATE',
    DEPARTMENT_PROFILE: 'DISH_EDITOR_DEPARTMENT_PROFILE',
    PORTION: 'DISH_EDITOR_PORTION',
    PORTIONS: 'DISH_EDITOR_PORTIONS',
    SIMILAR: 'DISH_EDITOR_SIMILAR',
    UPDATE: 'DISH_EDITOR_UPDATE',
    UPDATE_PORTION: 'DISH_EDITOR_UPDATE_PORTION',
  },
  DISHES_IMPORT: 'DISHES_IMPORT',
  EMAILS: {
    ALL: 'EMAILS_ALL',
    CONTACTS: 'EMAIL_CONTACTS',
    DELETE: 'EMAILS_DELETE',
    DELETE_THREAD: 'EMAILS_DELETE_THREAD',
    DRAFT: {
      CREATE: 'EMAILS_DRAFT_CREATE',
      SEND: 'EMAILS_DRAFT_SEND',
      UPDATE: 'EMAILS_DRAFT_UPDATE',
    },
    FOLDER_SETTINGS: 'EMAIL_FOLDER_SETTINGS',
    FOLDER_SETTINGS_UPDATE: 'EMAIL_FOLDER_SETTINGS_UPDATE',
    FOLDERS: 'EMAIL_FOLDERS',
    FOLDERS_STATE: 'EMAIL_FOLDERS_STATE',
    MARK_READ: 'EMAILS_MARK_READ',
    MOVE: 'EMAILS_MOVE',
    READ: 'EMAIL_READ',
    THREAD: 'EMAILS_THREAD',
  },
  EMERGENCY_CONTACTS: {
    ALL: 'EMERGENCY_CONTACTS_ALL',
    CREATE: 'EMERGENCY_CONTACTS_CREATE',
    DETAILS: 'EMERGENCY_CONTACTS_DETAILS',
    UPDATE: 'EMERGENCY_CONTACTS_UPDATE',
  },
  EVENT_TYPES: {
    CONFIGURATION: 'EVENT_TYPES_CONFIGURATION',
    CONFIGURATION_UPDATE: 'EVENT_TYPES_CONFIGURATION_UPDATE',
  },
  FILE_IMPORTS: {
    DELETE: 'FILE_IMPORTS_DELETE',
    DOWNLOAD: 'FILE_IMPORTS_DOWNLOAD',
    HISTORY: 'FILE_IMPORTS_HISTORY',
    REPORT: 'FILE_IMPORTS_REPORT',
  },
  FILES: 'FILES',
  LIST_DETAILS: {
    ACTIVE_PROCESSES: 'LIST_DETAILS_ACTIVE_PROCESSES',
    CUSTOMER: 'LIST_DETAILS_CUSTOMER',
    CUSTOMER_CONTACTS: 'LIST_DETAILS_CUSTOMER_CONTACTS',
    OPEN_TASKS: 'LIST_DETAILS_OPEN_TASKS',
    SUPPLIER_CONTACTS: 'LIST_DETAILS_SUPPLIER_CONTACTS',
  },
  MAINTENANCE: {
    STATUS: 'MAINTENANCE_STATUS',
  },
  MULTI_PROCESS_OFFER_PRINT_INFO: 'MULTI_PROCESS_OFFER_PRINT_INFO',
  OFFER_ELEMENT_DETAILS: 'OFFER_ELEMENT_DETAILS',
  OFFER_ELEMENT_EDITOR: {
    ADD_PRICE_LIST: 'OFFER_ELEMENT_EDITOR_ADD_PRICE_LIST',
    BROWSE_PAGE: 'OFFER_ELEMENT_EDITOR_BROWSE_PAGE',
    CATEGORIES: 'OFFER_ELEMENT_EDITOR_CATEGORIES',
    CREATE: 'OFFER_ELEMENT_EDITOR_CREATE',
    ELEMENT: 'OFFER_ELEMENT_EDITOR_ELEMENT',
    SIMILAR: 'OFFER_ELEMENT_EDITOR_SIMILAR',
    UPDATE: 'OFFER_ELEMENT_EDITOR_UPDATE',
    UPDATE_PRICE_LIST: 'OFFER_ELEMENT_EDITOR_UPDATE_PRICE_LIST',
  },
  OFFER_GROUP_DEFINITIONS: {
    ALL: 'OFFER_GROUP_DEFINITIONS_ALL',
    DELETE: 'OFFER_GROUP_DEFINITIONS_DELETE',
    DETAILS: 'OFFER_GROUP_DEFINITION_DETAILS',
    DISTRIBUTE: 'OFFER_GROUP_DEFINITION_DISTRIBUTE',
    GROUP: 'OFFER_GROUP_DEFINITION_GROUP',
    INSERT_INTO_OFFER: 'OFFER_GROUP_DEFINITION_INSERT_INTO_OFFER',
    SAVE: 'OFFER_GROUP_DEFINITIONS_SAVE',
    SUBGROUP: 'OFFER_GROUP_DEFINITION_SUBGROUP',
    SUBGROUP_DISHES: 'OFFER_GROUP_DEFINITION_SUBGROUP_DISHES',
    SUBGROUP_DISTRIBUTE: 'OFFER_GROUP_DEFINITION_SUBGROUP_DISTRIBUTE',
  },
  OFFER_PRINT_OWNER_PAGES: {
    DELETE: 'OFFER_PRINT_OWNER_PAGES_DELETE',
    SEARCH: 'OFFER_PRINT_OWNER_PAGES_SEARCH',
    UPLOAD: 'OFFER_PRINT_OWNER_PAGES_UPLOAD',
  },
  OFFER_PRINTS: {
    ACTIVE: 'OFFER_PRINTS_ACTIVE',
    ASSIGN_TO_OFFER: 'OFFER_PRINTS_ASSIGN_TO_OFFER',
    CREATE: 'OFFER_PRINTS_CREATE',
    SEARCH: 'OFFER_PRINTS_SEARCH',
    UPDATE_STATUS: 'OFFER_PRINTS_UPDATE_STATUS',
  },
  PPTX_IMPORTS: {
    ADD_DICTIONARY_ITEM: 'PPTX_IMPORTS_ADD_DICTIONARY_ITEM',
    DELETE: 'PPTX_IMPORTS_DELETE',
    DETAILS: 'PPTX_IMPORTS_DETAILS',
    DOWNLOAD_WORKBOOK: 'PPTX_IMPORTS_DOWNLOAD_WORKBOOK',
    EXTRACT_AGAIN: 'PPTX_IMPORTS_EXTRACT_AGAIN',
    IMPORT: 'PPTX_IMPORTS_IMPORT',
    LIST: 'PPTX_IMPORTS_LIST',
    SAVE: 'PPTX_IMPORTS_SAVE',
    SLIDE_IMAGE: 'PPTX_IMPORTS_SLIDE_IMAGE',
    SLIDE_PREVIEWS: 'PPTX_IMPORTS_SLIDE_PREVIEWS',
    UPLOAD: 'PPTX_IMPORTS_UPLOAD',
  },
  PROCESS: {
    ACTIVITY: 'PROCESS_ACTIVITY',
    ACTIVITY_GROUP: 'PROCESS_ACTIVITY_GROUP',
    CONTACTS: 'PROCESS_CONTACTS',
    CREATION_AI_SUGGESTIONS: 'PROCESS_CREATION_AI_SUGGESTIONS',
    CREATION_AI_SUGGESTIONS_ON_DEMAND: 'PROCESS_CREATION_AI_SUGGESTIONS_ON_DEMAND',
    CREATION_DEFAULT_DATA: 'PROCESS_CREATION_DEFAULT_DATA',
    DETAILS: 'PROCESS_DETAILS',
    EDIT: 'PROCESS_EDIT',
    MULTI_OFFER_DETAILS: 'PROCESS_MULTI_OFFER_DETAILS',
    MULTI_OFFERS: 'PROCESS_MULTI_OFFERS',
    OFFER_AI_CHAT_HISTORY: 'PROCESS_OFFER_AI_CHAT_HISTORY',
    OFFER_AI_CHAT_PROPOSAL: 'PROCESS_OFFER_AI_CHAT_PROPOSAL',
    OFFER_AI_CHAT_QUESTION: 'PROCESS_OFFER_AI_CHAT_QUESTION',
    OFFER_AI_CHAT_SEND: 'PROCESS_OFFER_AI_CHAT_SEND',
    OFFER_AI_CHAT_UNDO: 'PROCESS_OFFER_AI_CHAT_UNDO',
    OFFER_ATTACH_TO_EMAIL: 'PROCESS_OFFER_ATTACH_TO_EMAIL',
    OFFER_DETAILS: 'PROCESS_OFFER_DETAILS',
    OFFER_DETAILS_ELEMENT: 'PROCESS_OFFER_DETAILS_ELEMENT',
    OFFER_DETAILS_SUBGROUP: 'PROCESS_OFFER_DETAILS_SUBGROUP',
    OFFER_EMAILS: 'PROCESS_OFFER_EMAILS',
    OFFER_GROUP_COMMENT: 'PROCESS_OFFER_GROUP_COMMENT',
    OFFER_GROUP_DETAILS: 'PROCESS_OFFER_GROUP_DETAILS',
    OFFER_STATUS_ALLOWED_TRANSITIONS: 'PROCESS_OFFER_STATUS_ALLOWED_TRANSITIONS',
    OFFER_SUBGROUP_COMMENT: 'PROCESS_OFFER_SUBGROUP_COMMENT',
    TIMELINE_MESSAGES: 'PROCESS_TIMELINE_MESSAGES',
    TODO_INFO: 'PROCESS_TODO_INFO',
    UPDATE_STATUS: 'PROCESS_UPDATE_STATUS',
  },
  PROCESS_OFFERS: {
    COPY: 'PROCESS_OFFERS_COPY',
    SEARCH: 'PROCESS_OFFERS_SEARCH',
  },
  PROCESSES: {
    NEEDING_ATTENTION: 'PROCESSES_NEEDING_ATTENTION',
    SEARCH: 'PROCESSES_SEARCH',
  },
  PROCESSES_SHORT: 'PROCESSES_SHORT',
  REALIZATIONS: {
    ALL: 'REALIZATIONS_ALL',
    DOWNLOAD: 'REALIZATIONS_DOWNLOAD',
    HISTORY: 'REALIZATIONS_HISTORY',
    OFFER_HISTORY: 'REALIZATIONS_OFFER_HISTORY',
    UPDATE_LEAD: 'REALIZATIONS_UPDATE_LEAD',
    UPDATE_RESPONSIBLE: 'REALIZATIONS_UPDATE_RESPONSIBLE',
    UPDATE_STATUS: 'REALIZATIONS_UPDATE_STATUS',
  },
  REPORTS: {
    DOWNLOAD_CONTACTS: 'REPORTS_DOWNLOAD_CONTACTS',
    STATUS: 'REPORTS_STATUS',
  },
  RESOURCE_TASKS: 'RESOURCE_TASKS',
  SETTLEMENTS: {
    ALL: 'SETTLEMENTS_ALL',
    DELETE_PAYMENT: 'SETTLEMENTS_DELETE_PAYMENT',
    DELETE_QUOTE: 'SETTLEMENTS_DELETE_QUOTE',
    SAVE_PAYMENT: 'SETTLEMENTS_SAVE_PAYMENT',
    SAVE_QUOTE: 'SETTLEMENTS_SAVE_QUOTE',
    UPDATE_PAYMENT_PAID: 'SETTLEMENTS_UPDATE_PAYMENT_PAID',
  },
  STATISTICS: {
    PROCESSES: 'STATISTICS_PROCESSES',
  },
  SUPPLIER_DETAILS: 'SUPPLIER_DETAILS',
  SUPPORT: {
    REPORT: 'SUPPORT_REPORT',
  },
  TASKS: {
    ALL: 'TASKS_ALL',
    DETAILS: 'TASK_DETAILS',
    MESSAGE_ADD: 'TASK_MESSAGE_ADD',
  },
  TEAM_ANNOUNCEMENTS: {
    FEED: 'TEAM_ANNOUNCEMENTS_FEED',
    MARK_READ: 'TEAM_ANNOUNCEMENTS_MARK_READ',
    POST: 'TEAM_ANNOUNCEMENTS_POST',
  },
  USERS: {
    ALL: 'USERS_ALL',
    CURRENT: 'USER_CURRENT',
    ONBOARDING_DETAILS: 'USER_ONBOARDING_DETAILS',
    ONBOARDING_RUN: 'USER_ONBOARDING_RUN',
    SHORT: 'USERS_SHORT',
  },
} as const;
